import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-livsane',
  templateUrl: './livsane.component.html',
  styleUrls: ['./livsane.component.scss']
})
export class LivsaneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
